import { useContext } from "react";
import PhoneIcon from '@mui/icons-material/Phone';
import VideocamIcon from '@mui/icons-material/Videocam';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import DehazeIcon from '@mui/icons-material/Dehaze';
import { SocketContext } from "../../../context/socketContext";
import { useChatDatabase } from "../../../lib/chatDatabase";
import noAvatarImg from "../../../assets/noAvatar.png";
// import "../scss/chatHeader.scss";

const ChatHeader = ({ receiver }) => {
    const { onlineUsers } = useContext(SocketContext);
    const { clearChat, toggleDetail } = useChatDatabase();
    const isOnline = onlineUsers.includes(receiver?.id);

    return (
        <div className="top">
            <div className="user">
                <div className="backBtn" onClick={() => clearChat()}>
                    <ArrowBackIosNewIcon />
                </div>

                <img 
                    // src={receiver?.avatar || "/public/noAvatar.png"} 
                    src={receiver?.avatar || noAvatarImg}
                    alt="" 
                />

                <div className="texts">
                    <span>
                        {receiver?.name}
                    </span>

                    <p style={{ 
                        color: isOnline ? "limegreen" : "gray",
                        fontWeight: isOnline ? "500" : "normal",
                        fontSize: "14px",
                        margin: 0
                    }}>
                        {isOnline ? "Online" : "Offline"}
                    </p>
                </div>
            </div>

            <div className="icons">
                <PhoneIcon />
                <VideocamIcon />
                <DehazeIcon style={{ cursor: "pointer" }} onClick={toggleDetail} />
            </div>
        </div>
    );
};

export default ChatHeader;